export enum StatusWnioskuODodatkoweSwiadczenie {
  Zlozony = 1,
  Akceptacja,
  BrakAkceptacji,
}
